let startTime: number | undefined = undefined;

type SessionPausedCallback = ({ duration }: { duration: number }) => void;

const onBlur = (callback: SessionPausedCallback) => {
  if (startTime === undefined) return;
  callback({ duration: Math.round(performance.now() - startTime) });
  startTime = undefined;
};
const onFocus = () => {
  if (startTime) return;
  startTime = performance.now();
};

export const onSessionPaused = (callback: SessionPausedCallback) => {
  onFocus();

  const onVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      onBlur(callback);
    } else {
      onFocus();
    }
  };
  document.addEventListener("visibilitychange", onVisibilityChange);
  window.addEventListener("focus", onFocus);
  window.addEventListener("blur", () => onBlur(callback));
};
